import {post} from './httpBase'
//个人中心
export function getUserInfo(params) {
    return post("/region/info", params)
}
//积分
export function getUserPoint(params) {
    return post("/point/upoint", params)
}
//退出登录
export function InvokeToken(params) {
    return post("/region/invoke", params)
}
//邀请用户
export function inviting(params) {
    return post('/invite/inviteuser', params)
}
//退款详情
export function getRefund(params) {
    return post('/refund/v1/info', params)
}
//我的退款
export function getUserRefund(params) {
    return post('/v1/refund/my', params)
}
//个人中心二维码
export function TwoCode(params) {
    return post('/user/dispatcher/qrcode', params)
}


// WEBPACK FOOTER //
// ./src/service/memberService.js